import ReactApexChart from "react-apexcharts";

export function GanttChart({ timeLineData, type }: any) {
  const COLORS = [
    "#006AB3",
    "#F4BD00",
    "#238E21",
    "#F28E56",
    "#33b2df",
    "#64C760",
    "#76A974",
  ];

  const seriesData = timeLineData.map((entry: any, index: number) => {
    function getValueForX(name: any) {
      if (name === "Pose Processing Time" || name === "Club Processing Time") {
        const processingTimeIndex = timeLineData.findIndex(
          (item: any) => item?.name === "Processing Time"
        );

        return (
          timeLineData
            .slice(0, processingTimeIndex)
            .reduce((acc: any, val: any) => acc + val.value, 0) * 1000
        );
      }

      return (
        timeLineData
          .slice(0, index === 5 ? 3 : index)
          .reduce((acc: any, val: any) => acc + val.value, 0) * 1000
      );
    }

    let x = index > 0 ? getValueForX(entry?.name) : 0;

    return {
      x: entry.name,
      y: [x, x + entry.value * 1000],
    };
  });

  // Define colors for Gantt Chart series

  const series = [
    {
      data: seriesData,
    },
  ];

  const options = {
    chart: {
      height: 450,
      parentHeightOffset: 0,

      type: "bar",
      toolbar: false,
      zoom: false,
    },
    tooltip: {
      enabled: true,
      theme: "dark",
      custom: function ({ series, seriesIndex, dataPointIndex, w }: any) {
        var diffInSeconds: any = timeLineData[dataPointIndex].value;

        return (
          '<div style="background-color: #fff; border: 1px solid #ccc; padding: 10px; border-radius: 5px;">' +
          "<span style='color: #333; font-weight: bold;'>" +
          w.globals.labels[dataPointIndex] +
          ": </span>" +
          "<span style='color: #888;'>" +
          diffInSeconds.toFixed(2) +
          " secs</span>" +
          "</div>"
        );
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        dataLabels: {
          position: "center",
          hideOverflowingLabels: false,
        },
        colors: {
          ranges: [
            {
              color: "red", // Color for the range bars
            },
            // Add more color definitions for additional range bars if needed
          ],
        },
        borderRadius: 6, // Adjust the border radius to round the edges
        barHeight: "95%", // Adjust the height of the range bars
      },
    },
    colors: COLORS,
    dataLabels: {
      enabled: true,
      textAnchor: "middle",

      dropShadow: {
        enabled: true,
        top: 1,
        left: 1,
        blur: 2,
        opacity: 0.05,
      },
      hideOverflowingLabels: false,

      formatter: function (val: any, opts: any) {
        // var label = opts.globals.labels[opts.dataPointIndex];
        var diffInSeconds = (val[1] - val[0]) / 1000; // Convert milliseconds to seconds

        return diffInSeconds.toFixed(1) + "s"; // Display label and duration in seconds
      },
      style: {
        colors: ["#f3f4f5", "#fff"],
        fontWeight: 600,
        fontSize: "12px",
      },
    },

    formatter: function (value: any) {
      const val = value / 1000;

      return val.toFixed(2); // Convert milliseconds to seconds for X-axis labels
    },

    xaxis: {
      type: "category",
      labels: {
        show: true,
        rotate: -45,
        rotateAlways: false,
        hideOverlappingLabels: true,
        showDuplicates: false,
        trim: false,
        minHeight: undefined,
        maxHeight: 120,
        style: {
          colors: [],
          fontSize: "12px",
          fontFamily: "Helvetica, Arial, sans-serif",
          fontWeight: 400,
          cssClass: "apexcharts-xaxis-label",
        },
        offsetX: 0,
        offsetY: 0,
        formatter: function (value: any) {
          return value / 1000 + "s"; // Convert milliseconds to seconds for X-axis labels
        },
      },
      title: {
        text: type !== "preview" ? "Time(s)" : "",
        offsetX: 0,
        offsetY: 0,
        style: {
          color: "black",
          fontSize: "16px",
          fontFamily: "Helvetica, Arial, sans-serif",
          fontWeight: 600,
          cssClass: "apexcharts-xaxis-title",
        },
      },
      max:
        Number(
          timeLineData
            .filter(
              (state: any) =>
                state?.name !== "Pose Processing Time" &&
                state?.name !== "Club Processing Time"
            )
            .reduce((sum: any, state: any) => (sum += state?.value), 0) + 0.5
        ) * 1000,
    },
    yaxis: {
      show: type === "preview" ? false : true,
      labels: {
        show: true,
        align: "right",
        minWidth: 0,
        maxWidth: 160,
        style: {
          color: "black",
          fontSize: "14px",
          fontFamily: "Helvetica, Arial, sans-serif",
          fontWeight: 600,
          cssClass: "apexcharts-yaxis-label",
        },
        offsetX: 0,
        offsetY: 0,
        rotate: 0,
        formatter: (value: any) => {
          return value;
        },
      },
    },
    grid: {
      row: {
        colors: ["#f3f4f5", "#fff"],
        opacity: 1,
      },
    },
  };

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={options as any}
          series={series}
          type="rangeBar"
          height={type === "preview" ? 194 : 350}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
}
